import { NodeViewWrapper } from "@tiptap/react";

export function PageBreakView() {
  return (
    <NodeViewWrapper className="kd-pagebreak" data-drag-handle="" contentEditable={false}>
      <span>Page break</span>
    </NodeViewWrapper>
  );
}
